import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
// import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
// import HeaderMenu from 'components/Header/HeaderMenu';
import ThemeProvider from 'components/Theme';
import Home from 'components/Home/Home';
import EventDetails from 'components/Event/EventDetails';
// import Lives from 'components/Lives/Lives';
// import LivePlayer from 'components/Lives/LivePlayer';
import LivePlayer from 'components/Lives/LivePlayerOrchestrator';
import BrowserBarrier from 'components/UI/BrowserBarrier/BrowserBarrier';

import Replays from 'components/Replays/Replays';
import ReplayPlayer from 'components/Replays/ReplayPlayer';
import Contact from 'components/Contact/Contact';
import Medias from 'components/Medias/Medias';
import Help from 'components/Help/Help';
// import Agenda from 'components/Agenda/Agenda';
import DetectBrowser from 'components/UI/DetectBrowser/DetectBrowser';
import Account from 'components/Account/Account';
import AdminAccount from 'components/UI/Account/AdminAccount';
import AdminEvent from 'components/UI/Event/AdminEvent';
import AdminNews from 'components/UI/News/AdminNews';
import AdminFaq from 'components/UI/Faq/AdminFaq';
import AdminTheme from 'components/UI/Theme/AdminTheme';
import AdminMessage from 'components/UI/Message/AdminMessage';
import AdminOrchestrator from "components/UI/Orchestrator/AdminOrchestrator";
import AdminOrchestratorIndex from "components/UI/Orchestrator/AdminOrchestratorIndex";

import Feedback from "components/UI/Feedback/WrapperFeedback";
import AdminFeedback from "components/UI/Feedback/AdminFeedback";
import Announce from "components/UI/Announce/WrapperAnnounce";
import AdminAnnounce from "components/UI/Announce/AdminAnnounce";
import AdminQuiz from "components/UI/Quiz/AdminQuiz";
import AdminUtm from "components/UI/Utm/AdminUtm";
import Dashboard from "components/UI/Dashboard/Dashboard";

import AdminCMS from 'components/UI/Cms/AdminCms';
import CMSPage from 'components/UI/Cms/CMSPage';
import ScrollToTopOnMount from 'components/UI/ScrollToTopOnMount';
import NoMatch from 'components/NoMatch';
import Logout from 'components/Logout';
import Login from 'components/Login/Login';
import EventRegistration from 'components/Event/EventRegistration';
// import Legal from 'components/Legal/Legal';
// import Confidentiality from 'components/Confidentiality/Confidentiality';
// import HomeSubscribe from "./HomeSubscribe";
import { ResetPasswordRequest, ResetPasswordChallenge } from 'components/UI/ResetPassword';
import {
  login as initialeLogin,
  // isStateKnown as authStateKnown,
  // getCurrentUserRole,
  // isLoggedIn,
} from 'components/UI/Account/ducks/authentication';
import queryString from 'query-string';
// import properCase from 'mout/string/properCase';

// import PWAPrompt from 'react-ios-pwa-prompt'

// import capitalize from "lodash/capitalize";
import '../App.scss';

const styles = (theme) => {
  return {
    root: {
      // backgroundImage: `url(${require('assets/images/' + process.env.REACT_APP_SITE + '/background.jpg')})`,
      // backgroundPosition: '0 0',
      // backgroundSize: 'cover',
      // backgroundRepeat: 'no-repeat',
      [theme.breakpoints.down('sm')]: {
        // backgroundPosition: '0 0',
      },
    },
  };
};

class App extends Component {
  // constructor(props) {
  //   super(props);
  // }
  componentDidMount() {
    // document.title = 'Canal ' + properCase(process.env.REACT_APP_SITE);
    this.props.onMount();
  }
  render() {
    const {
      // loggedIn,
      // userRole,
      // authStateKnown,
      classes,
      // width,
      // $$data
    } = this.props;
    // console.log({authStateKnown})
    return (
      <div className={classes.root}>
        <ThemeProvider>
          <CssBaseline />
          <ScrollToTopOnMount />
          <DetectBrowser />
          <BrowserBarrier />
          {/*<PWAPrompt
            copyTitle={"Ajouter à l'écran d'accueil"}
            copyBody={"Ce site à le fonctionnement d'une WebApp. Ajoutez le à votre écran d'accueil pour y accéder hors connextion !"}
            copyShareButtonLabel={'1) Appuyez sur le bouton "Partager"'}
            copyAddHomeButtonLabel={"2) Appuyez sur ajouter \"Sur l'écran d'accueil\""}
            copyClosePrompt={'Annuler'}
            promptOnVisit={1} timesToShow={3}
            permanentlyHideOnDismiss={false}
            />*/}

            <Router>
              <Switch>
                {/*<Route exact path={'/replays'} component={({ match }) => <Home section={'replays'}/>} />*/}
                <Route exact path={'/'} component={({ match }) => <Home />} />
                <Route
                  exact={true}
                  path={'/event/:id'}
                  component={({ match }) => <EventDetails eventId={match.params.id} />}
                  />
                {/*<Route exact path={'/registration'} component={({ match }) => <EventRegistration />} />*/}
                <Route
                  exact={true}
                  path={'/subscribe/:id'}
                  component={({ match }) => <EventRegistration eventMatchId={match.params.id} />}
                  />
                <Route
                  exact={true}
                  path={'/subscribe'}
                  component={({ match }) => <EventRegistration/>}
                  />
                <Route exact path={'/login'} component={({ match }) => <Login />} />
                <Route exact path={'/_admin'} component={({ match }) => <Login kind="private"/>} />
                <Route exact path={'/help'} component={({ match }) => <Help />} />
                <Route exact path={'/contact'} component={({ match }) => <Contact />} />
                <Route exact path={'/medias'} component={({ match }) => <Medias />} />
                {/*<Route path={'/legal'} component={() => <Legal />} />
                <Route path={'/confidentiality'} component={() => <Confidentiality />} />*/}
                <Route path={'/confidentiality'} component={() => <CMSPage page="confidentiality" />} />*/}
                <Route path={'/legal'} component={() => <CMSPage page="legal" />} />*/}
                <Route path={'/cookies'} component={() => <CMSPage page="cookies" />} />*/}
                <Route
                  exact
                  path={'/live/:id'}
                  component={({ match }) => <LivePlayer match={match} onPanelToggle={this._panelToggle} />}
                  />

                <Route exact path={'/logout'} component={() => <Logout />} />
                <Route path="/rpwd" component={({ match }) => <ResetPasswordRequest match={match} />} />
                <Route path="/cpwd" component={() => <ResetPasswordChallenge />} />
                <Route path={'/replays/:id'} component={({ match }) => <ReplayPlayer match={match} />} />
                <Route path={'/replays'} component={({ match }) => <Replays />} />
                <Route
                  path="/staff/account/:action/:id"
                  component={({ match }) => <AdminAccount match={match} />}
                  />
                <Route
                  path="/staff/account/:action"
                  component={({ match }) => <AdminAccount match={match} />}
                  />
                <Route path="/staff/account" component={() => <AdminAccount />} />

                <Route
                  path="/staff/event/:action/:id"
                  component={({ match }) => <AdminEvent match={match} />}
                  />
                <Route path="/staff/event/:action" component={({ match }) => <AdminEvent match={match} />} />
                <Route path="/staff/event" component={() => <AdminEvent />} />

                <Route path="/staff/news/:action/:id" component={({ match }) => <AdminNews match={match} />} />
                <Route path="/staff/news/:action" component={({ match }) => <AdminNews match={match} />} />

                <Route path="/staff/faq/:action/:id" component={({ match }) => <AdminFaq match={match} />} />
                <Route path="/staff/faq/:action" component={({ match }) => <AdminFaq match={match} />} />

                <Route path="/staff/feedback/:eventId/:action/:id" component={({match}) => <AdminFeedback match={match}/>}/>
                <Route path="/staff/feedback/:eventId/:action" component={({match}) => <AdminFeedback match={match}/>}/>
                <Route path="/feedback/:eventId" component={({match}) => <Feedback match={match}/>}/>

                <Route path="/staff/announce/:eventId/:action/:id" component={({match}) => <AdminAnnounce match={match}/>}/>
                <Route path="/staff/announce/:eventId/:action" component={({match}) => <AdminAnnounce match={match}/>}/>
                <Route path="/announce/:eventId" component={({match}) => <Announce match={match}/>}/>

                <Route exact path={"/staff/quiz/:eventId/:action/:id"} component={({ match }) => <AdminQuiz match={match}/>} />
                <Route exact path={"/staff/quiz/:eventId/:action"} component={({ match }) => <AdminQuiz match={match}/>} />


                <Route exact path={"/staff/orchestrator/:eventId/:action"} component={({ match }) => <AdminOrchestrator match={match}/>} />
                <Route exact path={"/staff/orchestrator/list"} component={({ match }) => <AdminOrchestratorIndex match={match}/>} />


                <Route
                  path="/dashboard/:module/:action/:id"
                  component={({ match }) => <Dashboard match={match} />}
                  />
                <Route
                  path="/dashboard/:module/:action"
                  component={({ match }) => <Dashboard match={match} />}
                  />
                <Route
                  path="/dashboard/:module"
                  component={({ match }) => <Dashboard match={match} />}
                  />
                <Route
                  path="/dashboard"
                  component={({ match }) => <Dashboard match={match} />}
                  />

                <Route
                  path="/staff/theme/:action/:id"
                  component={({ match }) => <AdminTheme match={match} />}
                  />
                <Route path="/staff/theme/:action" component={({ match }) => <AdminTheme match={match} />} />

                <Route
                  path="/staff/utm/:action/:id"
                  component={({ match }) => <AdminUtm allowedRoles={['admin', 'staff']}match={match} />}
                  />
                <Route path="/staff/utm/:action" component={({ match }) => <AdminUtm allowedRoles={['admin', 'staff']}match={match} />} />
                <Route path="/staff/utm" component={() => <AdminUtm allowedRoles={['admin', 'staff']}/>} />


                <Route path="/staff/cms/:action/:id" component={({ match }) => <AdminCMS match={match} />} />
                <Route path="/staff/cms/:action" component={({ match }) => <AdminCMS match={match} />} />

                <Route
                  path="/staff/message/:action/:id"
                  component={({ match }) => <AdminMessage match={match} />}
                  />
                <Route
                  path="/staff/message/:action"
                  component={({ match }) => <AdminMessage match={match} />}
                  />
                <Route path="/account" component={({ match }) => <Account match={match} />} />
                <Route component={() => <NoMatch />} />
              </Switch>
            </Router>
          </ThemeProvider>
        </div>
      );
    }
  }

  function mapStateToProps(state) {
    const props = {
      // authStateKnown: authStateKnown(state),
      // loggedIn: isLoggedIn(state),
      // userRole: getCurrentUserRole(state),
    };
    return props;
  }
  function mapDispatchToProps(dispatch) {
    return {
      onMount: () => {
        const uri = queryString.parse(window.location.search);

        return dispatch(initialeLogin({ referer: uri.r }));
      },
    };
  }

  export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(App));



// WEBPACK FOOTER //
// ./src/components/App.js